var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Logger } from '@app/core';
import { SmartAlertService } from '../../../../core/smart-alert.service';
var logger = new Logger('@treasure-hunt:treasure-item.component.ts');
var Background;
(function (Background) {
    Background[Background["Normal"] = 0] = "Normal";
    Background[Background["Win"] = 1] = "Win";
    Background[Background["Lose"] = 2] = "Lose";
    Background[Background["Key"] = 3] = "Key";
})(Background || (Background = {}));
var TreasureReplyItemComponent = /** @class */ (function () {
    function TreasureReplyItemComponent(smartAlert) {
        this.smartAlert = smartAlert;
        this.openCase = -1;
        this.row = 0;
        this.rows = 10;
        this.itemsPerRow = 3;
        this.bg = Background;
        // Animation related data
        this.opened = false;
        this.openedParts = false;
        this.background = Background.Normal;
    }
    TreasureReplyItemComponent.prototype.ngOnInit = function () { };
    TreasureReplyItemComponent.prototype.ngOnDestroy = function () {
        if (this._actionsSubscriber) {
            this._actionsSubscriber.unsubscribe();
        }
        if (this._winningSubscriber) {
            this._winningSubscriber.unsubscribe();
        }
    };
    TreasureReplyItemComponent.prototype.ngOnChanges = function () {
        this.imitateOpening();
    };
    TreasureReplyItemComponent.prototype.imitateOpening = function () {
        if (this.openCase !== -1) {
            this.opened = false;
            this.openedParts = false;
            this.background = Background.Normal;
            switch (this.openCase) {
                case 0: {
                    this.startOpeningAnimation('win');
                    break;
                }
                case 1: {
                    this.startOpeningAnimation('key');
                    break;
                }
                case 2: {
                    this.startOpeningAnimation('lose');
                    break;
                }
            }
        }
    };
    TreasureReplyItemComponent.prototype.startOpeningAnimation = function (result) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.opened = true; // Prepare chest to be opened
                        return [4 /*yield*/, this.delay(550)];
                    case 1:
                        _b.sent(); // Breakpoint 1
                        this.openedParts = true; // Disable normal chest & show parts of chest
                        return [4 /*yield*/, this.delay(100)];
                    case 2:
                        _b.sent();
                        _a = result;
                        switch (_a) {
                            case 'win': return [3 /*break*/, 3];
                            case 'lose': return [3 /*break*/, 4];
                            case 'key': return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 8];
                    case 3:
                        {
                            this.background = Background.Win;
                            return [3 /*break*/, 8];
                        }
                        _b.label = 4;
                    case 4:
                        this.background = Background.Lose;
                        return [4 /*yield*/, this.delay(500)];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        this.background = Background.Key;
                        return [4 /*yield*/, this.delay(500)];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 8: return [4 /*yield*/, this.delay(1500)];
                    case 9:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TreasureReplyItemComponent.prototype.delay = function (time) {
        return new Promise(function (resolve) {
            setTimeout(function () {
                resolve(true);
            }, time);
        });
    };
    Object.defineProperty(TreasureReplyItemComponent.prototype, "isLastRow", {
        get: function () {
            return this.rows - 1;
        },
        enumerable: true,
        configurable: true
    });
    return TreasureReplyItemComponent;
}());
export { TreasureReplyItemComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-treasure/treasure-reply-item.component.ts.pre-build-optimizer.js